export default {"src":"/_next/static/media/image6.98fe23b1.svg","height":234,"width":359,"blurWidth":0,"blurHeight":0};